import React, { useState, useEffect } from 'react';
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import { get_skin_diary } from "../Services/Service";

const ImagesGalleryView = ({ skinMasterId, uuid }) => {
    const [skinResponse, setSkinResponse] = useState([]);
    console.log(skinMasterId, "skinMasterId")
    console.log(uuid, "uuid")
    console.log(skinResponse, "skinResponse")

    useEffect(() => {
        const fetchSkinDiary = async () => {
            try {
                const skinDiaryResponse = await get_skin_diary({ uuid: uuid, skinMasterId: skinMasterId });
                setSkinResponse(skinDiaryResponse.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchSkinDiary();
    }, [skinMasterId, uuid]);

    const renderItem = (item) => {
        return (
            <div className="image-gallery-item">
                <img src={item.original} alt={item.originalAlt} />
                <div className="image-gallery-description" dangerouslySetInnerHTML={{ __html: item.description }} />
            </div>
        );
    };

    return (
        <div>
            <ImageGallery
                items={skinResponse}
                showPlayButton={false}
                showFullscreenButton={false}
                renderItem={renderItem}
            />
        </div>
    );
}

export default ImagesGalleryView;
